import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { ModalProvider } from "./ModalContext";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ChatsPage from "./pages/ChatsPage";
import ProfilePage from "./pages/ProfilePage";
import UserPage from "./pages/UserPage";
import ContactsPage from "./pages/ContactsPage";

import UserModal from "./components/UserModal";
import PostModal from "./components/PostModal";

import { NotificationProvider } from "./context/NotificationContext";

import { collection, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import { useNotifications } from "./context/NotificationContext";
import GlobalNotifications from "./GlobalNotifications";


function App() {
  const [user, setUser] = useState(localStorage.getItem("user"));

  useEffect(() => {
    const checkUser = () => {
      setUser(localStorage.getItem("user"));
    };

    window.addEventListener("storage", checkUser);
    window.addEventListener("authChanged", checkUser);

    return () => {
      window.removeEventListener("storage", checkUser);
      window.removeEventListener("authChanged", checkUser);
    };
  }, []);

  

  return (
  <NotificationProvider> {/* ✅ ВАЖНО: СЮДА */}
    <GlobalNotifications user={user} />  {/* 💥 ВОТ ЭТО */}
    <ModalProvider>

      <Routes>

        <Route
          path="/"
          element={
            user ? <Navigate to="/chats" /> : <Navigate to="/login" />
          }
        />

        {!user ? (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        ) : (
          <>
            <Route path="/chats" element={<ChatsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/user/:username" element={<UserPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="*" element={<Navigate to="/chats" />} />
          </>
        )}

      </Routes>

      <UserModal />
      <PostModal />

    </ModalProvider>
  </NotificationProvider>
);
}

export default App;